import cx from 'classnames';
import React, { useContext } from 'react';

import Logo from './Logo';
import * as styles from './styles.css';
import useLogoPosition from '../../../Components/Context/Hooks/useLogoPosition';
import Box, { BoxProps } from '../../../Components/UI/Box';
import Branding from '../../../Components/UI/Branding';
import OverflowingFlexBox from '../../../Components/UI/OverflowingFlexBox';
import { Client } from '../../../Types/client';
import { Department } from '../../../Types/department';
import useGlobalContext from '../Context';
import { themeContext } from '../ThemeLoader';

interface NavigationProps extends BoxProps {
  isCollapsed: boolean;
  department?: Department;
  client?: Client;
}

const Navigation: React.FC<NavigationProps> = ({ isCollapsed, children, department, client, ...rest }) => {
  const { logo, type } = useGlobalContext();
  const { theme } = useContext(themeContext);
  const { inNavigation } = useLogoPosition(!isCollapsed);

  return (
    <Box
      element="nav"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      className={cx(styles['navigation'], { [styles['navigation--collapsed']]: isCollapsed })}
      {...rest}
    >
      <Box display="flex" paddingHorizontal={4} paddingVertical={3} alignItems="center">
        <Logo name={department?.name} logoUrl={logo} />
        {!isCollapsed && department && <h2 className={styles['department-name']}>{department.name}</h2>}
      </Box>
      {!isCollapsed && <OverflowingFlexBox scrollableClassName={styles['scrollable']}>{children}</OverflowingFlexBox>}
      {inNavigation && (
        <Branding
          size={isCollapsed ? 'small' : 'medium'}
          theme={theme}
          language={client?.language}
          country={client?.country}
          type={type}
        />
      )}
    </Box>
  );
};

export default Navigation;
